// @charset "utf-8"
import Vue from 'vue'
import Vuex from 'vuex'
import api from '@/api'

import userInfo from './modules/userInfo'

Vue.use(Vuex)
const state = {
    isFirst: false
}
const getters = {
}
const mutations = {
    SET_IS_FIRST (state, isFirst) {
        state.isFirst = isFirst
    }
}
const actions = {
    getLoginInfo ({ commit, dispatch }) {
        return api.getLoginInfo().then(info => {
            commit('SET_IS_FIRST', info.is_firstlogin)
        }).catch(() => {
        })
    }
}
const modules = {
    userInfo
}
export default new Vuex.Store({
    state,
    getters,
    mutations,
    actions,
    modules
})



// WEBPACK FOOTER //
// ./src/store/index.js